import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController, NavParams } from 'ionic-angular';
import { User } from '../../providers/user';
import { HomePage } from '../../pages/home/home';

/*
  Generated class for the AccountSignupForm component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'account-signup-form',
  templateUrl: 'account-signup-form.html'
})
export class AccountSignupFormComponent {
  login: { firstname?: string, listings?: string , email?: string, password?: string } = {};
  submitted = false;
  signFocus: any;

  constructor(
    public loading: LoadingController,
    public nav: NavController,
    public navParams: NavParams,
    public alert: AlertController,
    public user: User
  ) 
  {
    user.isConnected().then((user) => {
      if (user) {
        console.warn('user connected, redirecting to home..');
        this.nav.setRoot(HomePage);
      }
    });
      var id = this.navParams.get("Email");
      this.login.email = id;
  }

  onSignup(form) {
    let loader = this.loading.create({
      content: 'Please wait..',
      duration: 3000
    });
    debugger;
    this.submitted = true;
    if (form.valid) {
      loader.present();
      this.user.fb.auth().createUserWithEmailAndPassword(this.login.email, this.login.password)
      .then((user) => {
        debugger;
        if (user) {
          this.user.profile().updateProfile({
            displayName: this.login.firstname
          }).then(() => {
            this.user.updateListings(this.login.listings);
            loader.dismiss().then(() => {
              this.nav.setRoot(HomePage);
            });
          }, (e) => {
            loader.dismiss().then(() => {
              this.errorHandler(e);
            });
          });
        }
      })
      .catch((error) => {
        loader.dismiss().then(() => {
          setTimeout(() => {
            debugger;
            this.errorHandler(error);
          });
        });
      });
    }
  }

  errorHandler(error) {
    let errorCode = error.code;
    let errorMessage = error.message;
    let handler = User.errorHandler(errorCode, errorMessage);
    let alert = this.alert.create({
      title: handler.title,
      subTitle: handler.message,
      buttons: ['OK']
    });
    alert.present();
  }
}


// WEBPACK FOOTER //
// ./src/components/account-signup-form/account-signup-form.ts